import { ChangeDetectorRef, Component, ViewChild, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions, DayCellMountArg } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { calendarASAMBaseViewModel, calendarASAMDataDTO, platinumInstAMWiseNotCompleteCount, platinumInstNotCompleteCountData } from 'src/app/all-modules/account-supervisor/models/account-supervisor.model';
import { Router } from '@angular/router';
import { AccountSupervisorService } from 'src/app/all-modules/account-supervisor/service/account-supervisor.service';
import { CommonService } from '../../services/common.service';
import { SpinnerService } from '../../services/spinner.service';
import { CommonToastService } from '../../services/common-toast.service';
import moment from 'moment';
import { MESSAGE_CATEGORY_CONSTATNS } from '../../constants/constant';

@Component({
    selector: 'app-calendar-view-as-am',
    templateUrl: './calendar-view-as-am.component.html',
    styleUrl: './calendar-view-as-am.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CalendarViewAsAmComponent implements OnInit, OnDestroy {
  calendarData!: calendarASAMBaseViewModel;
  calendarDataOriginal!: calendarASAMBaseViewModel;
  isFirstTime = true;

  calendarCountData: platinumInstNotCompleteCountData[] = [];
  calendarAMWiseDataList: platinumInstAMWiseNotCompleteCount[] = [];
  selectedAMWiseData: platinumInstAMWiseNotCompleteCount[] = [];

  isLoading = true;
  selectedMonth: any;

  calendarOptions: CalendarOptions = {
    aspectRatio: 1.8,
    expandRows: true,
    fixedWeekCount: false,
    showNonCurrentDates: false,
    initialView: 'dayGridMonth',
    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
    height: 'auto',
    contentHeight: '550',
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: ''
    },
    dateClick: (arg) => this.handleDateClick(arg),
    dayCellDidMount: this.addCustomLabel.bind(this),
    datesSet: this.handleMonthChange.bind(this),
    validRange: {
      start: moment().startOf('month').format('YYYY-MM-DD')
    }
  };

  @ViewChild('fullCalendar', { static: false }) fullCalendar!: FullCalendarComponent;

  // initCounterEnter = 1;
  // initCounter = 1;
  isCalendarInitialized = false;
  debounceTimeout: any;
  isOpenPlatinumInstructionDialog = false;
  isLoadingPlatinumInstructionDialog = false;
  constructor(
    private router: Router,
    private asService: AccountSupervisorService,
    private commonService: CommonService,
    private spinnerService: SpinnerService,
    private commonToastService: CommonToastService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.selectedMonth = moment(new Date()).format("YYYY-MM-DD");
    this.getCalendarASAMData(this.selectedMonth);
  }

  ngAfterViewInit() {
    window.addEventListener('resize', this.onWindowResize.bind(this));
    this.onWindowResize(); 
  }

  onWindowResize() {
    if (this.fullCalendar) {
      const calendarApi = this.fullCalendar.getApi();
      calendarApi?.updateSize(); // Recalculate sizes on window resize
      this.alignCellWidths(); // Manually align cell widths
    }
  }
 openPlatinumInstDialog(date:string) {
  this.isOpenPlatinumInstructionDialog = true;
  this.isLoadingPlatinumInstructionDialog = false;
  this.selectedAMWiseData= this.calendarAMWiseDataList.filter(r=>r.jobDate === date);
 }
 closePlatinumInstDialog() {
  this.isOpenPlatinumInstructionDialog = false;
  this.isLoadingPlatinumInstructionDialog = false;
  this.selectedAMWiseData= [];
 }
  alignCellWidths() {
    const headerCells = document.querySelectorAll('.fc-col-header-cell');
    const bodyCells = document.querySelectorAll('.fc-daygrid-day');

    headerCells.forEach((headerCell, index) => {
      if (bodyCells[index]) {
        const headerWidth = headerCell.getBoundingClientRect().width;
        const bodyWidth = bodyCells[index].getBoundingClientRect().width;

        if (headerWidth !== bodyWidth) {
          (bodyCells[index] as HTMLElement).style.width = `${headerWidth}px`;
        }
      }
    });
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.onWindowResize.bind(this));
  }

  handleDateClick(arg: any) {
    this.openPlatinumInstDialog(arg.dateStr);
  }

  handleMonthChange(payload: any) {
    if (this.isCalendarInitialized) {
      this.selectedMonth = moment(payload.startStr).format("YYYY-MM-DD");
      this.debounceGetCalendarData(this.selectedMonth);
    } else {
      this.isCalendarInitialized = true;
    }
    // Manually trigger label re-rendering after month change
    setTimeout(() => {
      this.addLabelsToCalendar();
    }, 0);
  }

  debounceGetCalendarData(date: string) {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = setTimeout(() => {
      if (this.selectedMonth === date) { // Check if date is the same to avoid unnecessary calls
        this.getCalendarASAMData(date);
      }
    }, 300); // Adjust debounce time as needed
  }

  initCalendar() {
    this.calendarOptions = {
      aspectRatio: 1.8,
      fixedWeekCount: false,
      showNonCurrentDates: false,
      initialView: 'dayGridMonth',
      plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
      height: 'auto',
      contentHeight: 'auto',
      headerToolbar: {
        left: 'prev,next',
        center: 'title',
        right: ''
      },
      dateClick: (arg) => this.handleDateClick(arg), 
      dayCellDidMount: this.addCustomLabel.bind(this),
      datesSet: (arg) => {
        this.handleMonthChange(arg);
        this.addLabelsToCalendar();
        this.updateCalendarHeight(); // Ensure the height is updated properly
        this.alignCellWidths(); // Ensure header and body cells are aligned
      }
    };
  }

  updateCalendarHeight() {
    setTimeout(() => {
      if (this.fullCalendar) {
        const calendarApi = this.fullCalendar.getApi();
        calendarApi.updateSize(); // Update calendar size to fit the container
      }
    }, 100); // Allow slight delay for layout adjustments
  }

  addCustomLabel(info: DayCellMountArg) {
    const dateStr = this.formatDateToYYYYMMDD(info.date);
    this.calendarCountData.forEach((element: { jobDate: string; platinumInstNotCompleteCount: number; }) => {
      if (element.jobDate === dateStr) {
        const jobsLabel = document.createElement('div');
        jobsLabel.className = 'labors-label';
        jobsLabel.innerHTML = `<span class="number">${element.platinumInstNotCompleteCount}</span>`;
        info.el.appendChild(jobsLabel);
      }
    });
  }

  addLabelsToCalendar() {
    if (this.fullCalendar) {
      this.removeElementsByClass('labors-label');
      const calendarApi = this.fullCalendar.getApi();
      const view = calendarApi.view;
      const dateCells = document.querySelectorAll('.fc-daygrid-day');
      dateCells.forEach((dayCell: any) => {
        if (dayCell.classList.contains('fc-daygrid-day') && dayCell.dataset.date !== undefined) {
          const dateStr = this.formatDateToYYYYMMDD(new Date(dayCell.dataset.date));
          if (this.commonService.areDatesInSameYearAndMonth(this.selectedMonth, dateStr)) {
            this.calendarCountData.forEach((element: { jobDate: string; platinumInstNotCompleteCount: number; }) => {
              if (element.jobDate === dateStr) {
                const jobsLabel = document.createElement('div');
                jobsLabel.className = 'labors-label';
                jobsLabel.innerHTML = `<span class="number">${element.platinumInstNotCompleteCount}</span>`;
                dayCell.appendChild(jobsLabel);
              }
            });
          }
        }
      });
    } else {
      // If fullCalendar is not ready, retry after a short delay
      setTimeout(() => {
        this.addLabelsToCalendar();
      }, 100); // Adjust the delay time if necessary
    }
  }
  getCalendarASAMData(date: string) {
    this.calendarData  =  {} as calendarASAMBaseViewModel;
    this.calendarDataOriginal =  {} as  calendarASAMBaseViewModel;
    this.calendarAMWiseDataList = [];
    this.calendarCountData = [];
    const data: calendarASAMDataDTO = { date };
    this.spinnerService.show();
    this.asService.getCalendarDataForASAM(data).subscribe({
      next: (response: calendarASAMBaseViewModel) => {
        if (this.commonService.isNotNULLEmptyUndefind(response)) {
          this.calendarData = response;
          this.calendarDataOriginal = response;
         
          if (this.commonService.isNotNULLEmptyUndefindArray(response.calendarAMWiseDataList)) {
            this.calendarAMWiseDataList = response.calendarAMWiseDataList;
          }
          if (this.commonService.isNotNULLEmptyUndefindArray(response.calendarCountData)) {
            this.calendarCountData = response.calendarCountData;
          }
          setTimeout(() => {
            this.isFirstTime = false;
            if (this.isCalendarInitialized) {
              this.initCalendar();
            }
            this.isLoading = false;
            this.spinnerService.hide();
            this.addLabelsToCalendar();
          }, 200);
        }
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        }
      }
    });
  }

  formatDateToYYYYMMDD(date: Date): string {
    const isoString = date.toISOString();
    return isoString.split('T')[0];
  }
  goToDueReport() {
    this.router.navigate(['/account-manager/platinum-instruction-due']);
  }
  removeElementsByClass(className: string) {
    const elements = document.getElementsByClassName(className);
    while (elements.length > 0) {
      elements[0].parentNode?.removeChild(elements[0]);
    }
  }
}
